<template>
  <div class="flex justify-center">
    <div
      class="min-w-0 max-w-full grow lg:max-w-[1184px] lg:basis-full lg:px-32"
      :class="innerClass"
      data-test="container-wrapper"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { VNode } from 'vue'

defineSlots<{
  default(): VNode[]
}>()

const { innerClass = 'md:px-24' } = defineProps<{
  innerClass?: string
}>()
</script>
